/* app/js/src/components/graphics/edit/fields/position.component.scss */
.cursor-pointer {
  cursor: pointer;
}
* {
  box-sizing: border-box;
}
.container {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-justify-content: space-around;
  -ms-flex-pack: space-around;
  justify-content: space-around;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  width: 73px;
  height: 42px;
}
.option {
  background-color: #d9dde2;
  width: 23px;
  height: 12px;
  cursor: pointer;
}
.selected {
  background-color: #7d8fa1;
}
/*# sourceMappingURL=position.component.css.map */
